<template>
    <v-snackbar :timeout="timeout"
                :top="y === 'top'"
                :bottom="y === 'bottom'"
                :right="x === 'right'"
                :left="x === 'left'"
                :multi-line="mode === 'multi-line'"
                :vertical="mode === 'vertical'"
                :color="color"
                v-model="show">
        {{ message }}
        <v-btn flat :color="btnColor" v-on:click.native="close()">{{ btnText }}</v-btn>
    </v-snackbar>
</template>
<script>
    /* eslint-disable */
    export default {
        data() {
            return {
                show: false,
                y: 'top',
                x: null,
                mode: 'multi-line',
                color: 'info',
                timeout: 8000,
                message: '',
                btnColor: 'white',
                btnText: 'Cerrar',
                resolve: null,
                reject: null
            }
        },
        methods: {
            open(message, options) {
                if (typeof options !== 'undefined') {
                    if (typeof options.y !== 'undefined')
                        this.y = options.y
                    if (typeof options.x !== 'undefined')
                        this.x = options.x
                    if (typeof options.mode !== 'undefined')
                        this.mode = options.mode
                    if (typeof options.color !== 'undefined')
                        this.color = options.color
                    if (typeof options.timeout !== 'undefined')
                        this.timeout = options.timeout
                    if (typeof options.btnColor !== 'undefined')
                        this.btnColor = options.btnColor
                    if (typeof options.timeout !== 'undefined')
                        this.btnText = options.btnText
                }   
                this.message = message
                this.show = true
                return new Promise((resolve, reject) => {
                    this.resolve = resolve
                    this.reject = reject
                })
            },
            close() {
                this.show = false
                this.resolve(true)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/utils/Snackbar.vue